module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/4m-3d814660e2ad8d28d76d98a19518b031.jpg";